import { Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { useCan, type Nivel, type Seccion } from './queries';

/**
 * Muestra la página solo si el staff tiene la sección. Es solo UX: la API responde 403 a cualquier
 * ruta de una sección que no tenga (en el legacy el bloqueo era solo visual).
 */
export function PermissionGate({
  seccion,
  nivel = 'ver',
  children,
}: {
  seccion: Seccion;
  nivel?: Nivel;
  children: ReactNode;
}) {
  if (useCan(seccion, nivel)) return <>{children}</>;
  return (
    <section className="panel-vidrio mx-auto max-w-xl text-center">
      <span className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-morado-700 text-white">
        <Lock size={24} aria-hidden />
      </span>
      <h1 className="text-2xl font-extrabold text-azul-texto">Sin acceso a esta sección</h1>
      <p className="mt-3 text-texto-2">
        Tu cuenta no tiene permiso para esta parte del panel. Si lo necesitas, pídelo a un
        administrador.
      </p>
      <Link to="/" className="btn-cs btn-primario mt-6">
        Ir al inicio
      </Link>
    </section>
  );
}
